// module factories are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__.O(undefined, ["vendors-node_modules_loadable_component_dist_loadable_esm_js-node_modules_reduxjs_toolkit_dis-ba6e52"], () => (__webpack_require__("../../node_modules/@sentry/webpack-plugin/src/sentry-webpack.module.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_loadable_component_dist_loadable_esm_js-node_modules_reduxjs_toolkit_dis-ba6e52"], () => (__webpack_require__("./src/js/app.tsx")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
